import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiEye } from '@mdi/js';

import { _ } from '../../functions/translator'

class ViewButton extends React.Component{

    handleClick = () => {
        this.props.popUpMenuChange({ show: true, expanded: true })
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiEye } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Ver más') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ViewButton)